'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var browserMiddleware = require('./_chunks/browserMiddleware-yPyURfGu.cjs');
var getIt = require('get-it');
function defineDeprecatedCreateClient(createClient) {
  return function deprecatedCreateClient(config) {
    browserMiddleware.printNoDefaultExport();
    return createClient(config);
  };
}
const exp = browserMiddleware.defineCreateClientExports(browserMiddleware.envMiddleware, browserMiddleware.SanityClient);
const requester = exp.requester;
const createClient = exp.createClient;
const deprecatedCreateClient = defineDeprecatedCreateClient(createClient);
exports.BasePatch = browserMiddleware.BasePatch;
exports.BaseTransaction = browserMiddleware.BaseTransaction;
exports.ClientError = browserMiddleware.ClientError;
exports.ObservablePatch = browserMiddleware.ObservablePatch;
exports.ObservableSanityClient = browserMiddleware.ObservableSanityClient;
exports.ObservableTransaction = browserMiddleware.ObservableTransaction;
exports.Patch = browserMiddleware.Patch;
exports.SanityClient = browserMiddleware.SanityClient;
exports.ServerError = browserMiddleware.ServerError;
exports.Transaction = browserMiddleware.Transaction;
Object.defineProperty(exports, 'unstable__adapter', {
  enumerable: true,
  get: function () {
    return getIt.adapter;
  }
});
Object.defineProperty(exports, 'unstable__environment', {
  enumerable: true,
  get: function () {
    return getIt.environment;
  }
});
exports.createClient = createClient;
exports.default = deprecatedCreateClient;
exports.requester = requester;
//# sourceMappingURL=index.browser.cjs.map
